import React, { Component } from 'react';
import { HashLink as Link } from 'react-router-hash-link';
import PropTypes from 'prop-types';

export default class NavigationLink extends Component {
  render() {
    var isActive =
      this.context.router.route.location.pathname === this.props.to;
    var className = isActive ? 'is-active' : '';

    return (
      <Link className={className} {...this.props}>
        {this.props.children}
      </Link>
    );
  }
}
NavigationLink.contextTypes = {
  router: PropTypes.object,
};



// WEBPACK FOOTER //
// ./src/components/Layout/Navigation/NavigationLink.jsx